export default __webpack_public_path__ + "static/media/support-email.dbbd78b5.svg";